import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "check, checkmark" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M1.66663 10.333L6.13721 13.6663L14.3333 2.33301",
        stroke: "currentColor",
        "stroke-linecap": "round"
      })
    ], -1)
  ])))
}
export default { render: render }